export const COMMON_API_URL = 'https://api.ellow.io'
export const REACT_APP_RECRUITER = 'https://api.ellow.io/recruiter/api/v1/tg'
export const REACT_APP_JOB = 'https://api.ellow.io/job/api/v1/tg'
export const REACT_APP_CANDIDATE_FRELLANCER = 'https://api.ellow.io/candidate-freelancer/api/v1/tg';
export const REACT_APP_CUSTOMER = 'https://api.ellow.io/Customer/api/v1/tg'
export const REACT_APP_CANDIDATE = 'https://api.ellow.io/candidate/api/v1/tg'
export const REACT_APP_PROFILE = 'https://api.ellow.io/profile/api/v1/tg'
export const REACT_APP_CUSTOMERSETTINGS = 'https://api.ellow.io/customersettings/api/v1/tg'
export const REACT_APP_CANDIDATEFILTER = 'https://api.ellow.io/candidatefilter/api/v1/tg'
export const REACT_APP_TIMESHEET = 'https://api.ellow.io/timesheet/api/v1/tg'
export const REACT_APP_CONTRACT = 'https://api.ellow.io/contract/api/v1/tg'
export const REACT_APP_PUBLICDATA = 'https://api.ellow.io/candidatepublicdata/api/v1/tg'
export const REACT_APP_JOBFILTER = 'https://api.ellow.io/jobfilter/api/v1/tg'
export const REACT_APP_MESSAGING = 'https://api.ellow.io/messaging/api/v1/tg'
export const REACT_APP_CONTRACTSIGN = 'https://api.ellow.io/contractsign/api/v1/tg'
export const REACT_APP_TIMESHEETREPORTS = 'https://api.ellow.io/timesheetreports/api/v1/tg'
export const REACT_APP_COMMON = 'https://api.ellow.io/common/api/v1/tg'
export const REACT_APP_TIMESHEETPAYMENT = 'https://api.ellow.io/timesheetpayment/api/v1/tg'


